// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"cb281e76","453":"9595aaab"}[chunkId] + ".chunk.js";
};